import getPageAnalyticsTag from './getPageAnalyticsTag';
import getDeviceRuleContext from './getDeviceRuleContext';
import getSiteRuleContext from './getSiteRuleContext';

/**
 * Builds the `analyticsTags` / `ruleContexts` pair attached to Algolia search
 * requests (CON-8651).
 *
 * One function used by both sides so the browser and the server render cannot
 * drift: the browser feeds it `location`/`navigator`, the server feeds it the
 * `x-original-host` and `user-agent` headers.
 *
 * Either array is omitted entirely when nothing resolved, so an unclassifiable
 * page or host sends no parameter at all rather than an empty one.
 *
 * @param {object} context
 * @param {string} [context.pathname]
 * @param {string} [context.routeKind] getCatchAllRouteKind output.
 * @param {string} [context.routeKindPath] Path `routeKind` was resolved for.
 * @param {string} [context.userAgent]
 * @param {string} [context.host]
 * @param {string} [context.cookieStoreHostName] Honoured outside production.
 * @param {boolean} [context.isProduction]
 * @returns {{ analyticsTags?: string[], ruleContexts?: string[] }}
 */
const buildAlgoliaAnalyticsParams = ({
  pathname,
  routeKind,
  routeKindPath,
  userAgent,
  host,
  cookieStoreHostName,
  isProduction,
} = {}) => {
  const pageTag = getPageAnalyticsTag({ pathname, routeKind, routeKindPath });
  const siteContext = getSiteRuleContext({
    host,
    cookieStoreHostName,
    isProduction,
  });
  const ruleContexts = [siteContext, getDeviceRuleContext(userAgent)].filter(
    Boolean
  );

  return {
    ...(pageTag ? { analyticsTags: [pageTag] } : {}),
    ...(ruleContexts.length ? { ruleContexts } : {}),
  };
};

export default buildAlgoliaAnalyticsParams;
